import { TextField } from "@mui/material";
import React from "react";

export default class Search extends React.Component<{sx?: any, onChange?: (input: string) => void}, {}> {

    render() {
        return (
            <TextField
                placeholder="Search"
                color="primary"
                sx={{
                    '& .MuiOutlinedInput-root': {
                        height: '40px',
                        borderRadius: '20px',
                        ...this.props.sx
                    },
                    ...this.props.sx,
                }}
                onChange={(event) => {if (this.props.onChange) this.props.onChange(event.target.value)}}
            />
        );
    }
}